import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";

import { goToScene } from "../main";

import { playerState } from "../state/stateManager";
import Bill from "../actors/characters/bill";

export default class BillsHouse extends ex.Scene {
  constructor() {
    super();
    const player = new Player(20 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.wearingVeil = false;
    this.player.z = 5;
    this.bill = new Bill({ x: 14 * 16, y: 6 * 16 }, "billsHouse");
    this.bill.z = 5;
  }
  onInitialize(engine) {
    Resources.BillsHouse.addToScene(this);
    console.log("billshouse: adding player: ", this.player);
    this.player.lastDir = "up";

    this.add(this.player);

    this.camera.zoom = 1;

    this.door = new ex.Trigger({
      pos: new ex.Vector(19 * 16, 19 * 16 + 8),
      width: 48,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("crossroads", { x: 32 * 16, y: 12 * 16, direction: "down" });
      },
    });
    this.add(this.door);

    this.player.on("collisionstart", (e) => {
      if (e.other.owner.name === "bill") {
        this.bill.startInteraction(this.player.lastDir, this.player);
      }
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    let content = playerState.getContent();
    // if (content.npcLocations.bill.location == 0) {
    this.add(this.bill);
    // }
  }
  onPostUpdate() {}
}
